export const SEARCH_TYPES = {
  BEGIN_SEARCH: 'BEGIN_SEARCH',
  ADD_SHORTLISTED: 'ADD_SHORTLISTED',
  SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
  CLEAR_SEARCH: 'CLEAR_SEARCH',
};

export const beginSearchAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: SEARCH_TYPES.BEGIN_SEARCH,
      payload: data,
    });
  };
};

export const setSearchResultAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: SEARCH_TYPES.SET_SEARCH_RESULT,
      payload: data,
    });
  };
};

export const addShortlistedAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: SEARCH_TYPES.ADD_SHORTLISTED,
      payload: data,
    });
  };
};

export const clearSearchAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: SEARCH_TYPES.CLEAR_SEARCH,
    });
  };
};
